const timestampDisplay = (unixTimestamp: string | number): string => {
	const date = new Date(Number(unixTimestamp) * 1000)
	return date.toLocaleString()
}

export { timestampDisplay }
